import { render, staticRenderFns } from "./ImageDetails.vue?vue&type=template&id=ac8bd7ec&scoped=true"
import script from "./ImageDetails.vue?vue&type=script&lang=js"
export * from "./ImageDetails.vue?vue&type=script&lang=js"
import style0 from "./ImageDetails.vue?vue&type=style&index=0&id=ac8bd7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8bd7ec",
  null
  
)

export default component.exports